import React from "react";
import "./Ruko.scss";
import data from "./data.json";
import Card from "../../Component/Landscape/Landscape";
import Quantumimages from "../../Media/Ruko/Quantum/Quantum";
import Faradayimages from "../../Media/Ruko/Faraday/Faraday";
import CityHubimages from "../../Media/Ruko/City Hub/City Hub";
import Edisonimages from "../../Media/Ruko/Edison/Edison";
import Melodyimages from "../../Media/Ruko/Melody/Melody";
import Downtownimages from "../../Media/Ruko/Downtown/Downtown";
import Carsonimages from "../../Media/Ruko/Carson/Carson";

const imageMap = {
  Quantumimages,
  Faradayimages,
  CityHubimages,
  Edisonimages,
  Melodyimages,
  Downtownimages,
  Carsonimages,
  // Add other image arrays here if you have more sets
};

const produk = () => {
  return (
    <div id="ruko" className="produkruko">
      <div className="cardhome-containerf">
        {data.cards.map((card, index) => {
          // Determine the logo dynamically
          // Determine the logo dynamically
          return (
            <Card
              key={index}
              carousel={imageMap[card.imagesKey]}
              title={card.title}
              subtitle={card.subtitle}
              price={card.price}
              subprice={card.subprice}
              details={card.details}
              whatsappLink={card.whatsappLink} // Pass the WhatsApp link
            />
          );
        })}
      </div>
    </div>
  );
};

export default produk;
